import "./loading.scss";

const Loading = () => {
  // const length = 12
  return (
    <div className="wrapper-loading">
      <div className="loadingio-spinner-spinner-p82981c5re">
        <div className="ldio-junniiro31a">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};
export default Loading;
